import {Component, Inject, LOCALE_ID, OnInit} from '@angular/core';
import {PasswordChange} from '../model/PasswordChange';
import { HttpClient } from '@angular/common/http';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ErrorDialogComponent} from '../error-dialog/error-dialog.component';
import {OkDialogComponent} from '../ok-dialog/ok-dialog.component';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'lib-password-change',
    templateUrl: './password-change.component.html',
    styleUrls: ['./password-change.component.css'],
    standalone: false
})
export class PasswordChangeComponent implements OnInit {

  model = new PasswordChange('', '', '');
  private translate: TranslateService;
  title = 'Zmena hesla';

  constructor(
    private http: HttpClient,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: {translate: TranslateService},
    @Inject(LOCALE_ID) private locale: string,
    public dialogRef: MatDialogRef<PasswordChangeComponent>
  ) {
  }

  ngOnInit(): void {
    this.translate = this.data.translate;
    this.translate.use(this.locale);
  }

  passwordChange() {

      if (this.model.passwordNew1 !== this.model.passwordNew2) {
          this.dialog.open(ErrorDialogComponent, {
            data: {
              message: this.translate.instant('Zadané heslá sa nezhodujú.')
            }
          });
          return;
      }

      this.http
          .post('/ais/rest/portal/user/password', this.model)
          .subscribe(
              () => {
                  this.dialog.open(OkDialogComponent, {
                    data: {
                      message: this.translate.instant('Heslo bolo úspešne zmenené.')
                    }
                  }).afterClosed().subscribe(
                      () => this.dialogRef.close()
                  );
              },
              (error) => {
                  this.dialog.open(ErrorDialogComponent, {
                    data: {
                      message: error.error.message
                    }
                  });
              }
          );

  }
}
